import React from "react";
import './Story.css';

export default function Story () {

    return (
        <div className="story-container">
            <h1 className="story-title">Who am I?</h1>
            <p className="story-text">
                I am a full-stack developer with a passion for creating
                beautiful and functional web applications. I have a
                background in graphic design and have worked with
                companies such as <a href="https://www.vegvesen.no/">El Camino</a> and <a href="https://www.vegvesen.no/">JBS Sport</a>.
                I am currently working as a full-stack consultant at <a href="https://www.salt.study">SALT</a>.
            </p>

        </div>
    )
}